import React, { Component } from 'react';
import { Modal, Form, Input, message, Spin } from 'antd';
import { withRouter } from 'react-router-dom';

import { CognitoUserPool, CognitoUser } from 'amazon-cognito-identity-js';
import { POOL_DATA } from "../../../utils/config"

import './Newpwd.css';

class Newpwd extends Component {

  state = {
    visible: false,
    codeStatus: '',
    codeError: '',
    loading: false,
  };

  componentWillReceiveProps(thisProps) {
    if (thisProps.visible === true) {
      this.setState({
        visible: true
      })
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({
      codeStatus: '',
      codeError: '',
    });

    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          loading: true,
        });

        const userPool = new CognitoUserPool(POOL_DATA);

        const userData = {
          Username : this.props.userName,
          Pool : userPool
        };

        const cognitoUser = new CognitoUser(userData);
        cognitoUser.confirmPassword(values.code, values.password, {
          onSuccess: () => {
            this.setState({
              visible: false,
              loading: false,
            });
            message.success('You\'ve set a new password, remember it.');
            this.props.history.push('/login');
          },
          onFailure: (err) => {
            if (String(err).indexOf('Invalid') !== -1) {
              this.setState({
                codeStatus: 'error',
                codeError: 'Invalid code, please check and try again',
              })
            } else {
              message.error(String(err).split(': ')[1]);
            }
            this.setState({
              loading: false,
            });
          }
        });
      }
    });
  };

  handleResend = () => {

    const userPool = new CognitoUserPool(POOL_DATA);

    const userData = {
      Username : this.props.userName,
      Pool : userPool
    };

    const cognitoUser = new CognitoUser(userData);
    cognitoUser.forgotPassword({
      onSuccess: () => {
        message.success('E-mail has been resent, please check again.')
      },
      onFailure: (err) => {
        message.error(String(err));
      }
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false,
    });
    this.props.setVisible();
  };

  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('password')) {
      callback('Password is not match.');
    } else {
      callback();
    }
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Modal
        visible={this.state.visible}
        className="Newpwd"
        onCancel={this.handleCancel}
      >
        <div className="inner-modal">
          <h2>Confirm Your Email Address</h2>
          <p>We've sent a mail to your verified E-mail address, You need to fill in the verification code you received, and set your new password</p>
          <Spin spinning={this.state.loading}>
          <Form onSubmit={this.handleSubmit}  className="newpwd-form">
            <Form.Item
              validateStatus={this.state.codeStatus}
              help={this.state.codeError}
              hasFeedback
            >
              <span>Verification Code</span>
              {getFieldDecorator('code')(
                <Input
                  type="number"
                  addonAfter={<a onClick={this.handleResend}>Resend</a>}
                  placeholder="Verification Code"
                />)}
            </Form.Item>
            <Form.Item hasFeedback>
              <span>New Password</span>
              {getFieldDecorator('password', {
                rules: [
                  { required: true, message: 'Please input your Password '},
                  { min: 8, message: 'Password is too short ( need more than 8 characters ).' },
                  { validator: this.checkConfirm }
                ],
              })(
                <Input type="password" placeholder="New Password" />
              )}
            </Form.Item>
            <Form.Item hasFeedback>
              <span>Confirm password</span>
              {getFieldDecorator('confirm', {
                rules: [
                  { required: true, message: 'Please repeat your Password' },
                  { validator: this.checkPassword }],
              })(
                <Input type="password" placeholder="Enter again" onBlur={this.handleConfirmBlur}/>
              )}
            </Form.Item>
            <Form.Item className="newpwd-button">
              <button>Confirm</button>
            </Form.Item>
          </Form>
          </Spin>
        </div>
      </Modal>
    )
  }
}

const WrappedNewpwd = Form.create()(Newpwd);
export default withRouter(WrappedNewpwd);


// WEBPACK FOOTER //
// ./src/Containers/GetStarted/components/Newpwd.js